import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  IconButton,
  Box,
  CircularProgress,
  Divider,
  Chip,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Delete, Get, Post, Put } from "../../../services/apiServices";
import { networkUrls } from "../../../services/networkurls";
import IndustryTrackModal from "../../../components/IndustryTrackModal/IndustryTrackModal";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from '@mui/icons-material/Delete';
import { Button } from "@mui/joy";
import ReuseableSnackbar from "../../../components/Snackbar/Snackbar";

const IndustryTrackDetails = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [industryTrack, setIndustryTrack] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);
    const [saving, setSaving] = useState<boolean>(false);
    const [snackbarInfo, setSnackbarInfo] = useState({
      color: "",
      message: "",
    });
     const [isShowSnackbar, setIsShowSnackbar] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalInitialData, setModalInitialData] = useState<any | null>(null);
  const [isMode, setIsMode] = useState("");

  const getIndustryTrackDetails = async () => {
    try {
      const response = await Get(`${networkUrls.singleIndustryTrack}/${id}`, true);
      if (response?.status === 200) {
        setIndustryTrack(response?.data?.data || null);
      }
    } catch (error) {
      console.error("Error fetching industry track:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getIndustryTrackDetails();
  }, []);

  const handleOpenEdit = () => {
    setModalInitialData(industryTrack);
    setIsMode("edit");
    setIsModalOpen(true);
  };

    const handleOpenDelete = () => {
    setModalInitialData(industryTrack);
    setIsMode("delete");
    setIsModalOpen(true);
  };

  const handleEditSave = async (payload: any) => {
    setSaving(true);
    try {
      
      const response=   await Put(`${networkUrls.updateIndustryTrack}/${id}`, {
          "Industry_Name": payload.industryName,
          Manager: payload.manager,
          "SPOC_1": payload.spoc1,
          "SPOC_2": payload.spoc2,
          "SPOC_3": payload.spoc3,
          Members: payload.members || [],
        }, true);

        if(response?.status===200){
setSaving(false);
          setIsShowSnackbar(true);
          setSnackbarInfo({
            color: "success",   
            message: response?.response?.message || "Industry Track updated successfully",
          });
          getIndustryTrackDetails();
        } else{
          setIsShowSnackbar(true);
          setSnackbarInfo({ 
            color: "error",
            message: response?.response?.message || "Failed to update Industry Track",
          }); 
        }

    } catch (err) {
      console.error("Error saving industry track:", err);
    } finally {
      setIsModalOpen(false);
      setSaving(false)
    }
  }


  const handleSave = async (payload: any) => {

    if(isMode==="edit"){
      handleEditSave(payload);
    }else if(isMode==="delete"){
      handleDelete();
    }
    
  };


  const handleDelete = async () => {
    setSaving(true)
    if (!id) return;
    setLoading(true);   
    try {
      const response = await Delete(`${networkUrls.deleteIndustryTrack}/${id}`, true);      
      if (response?.status === 200) {
        setIsShowSnackbar(true);
        setSnackbarInfo({
          color: "success",
          message: response?.data?.message || "Industry Track deleted successfully",
        });
        setSaving(false )
        
          
          navigate("/industry-track");
        
      } else {
        setIsShowSnackbar(true);
        setSnackbarInfo({   
          color: "error",   
          message: response?.data?.error || "Failed to delete Industry Track",
        }); 
      }   
    } catch (error) {
      console.error("Error deleting industry track:", error);
    } finally {
      setLoading(false);
      setIsModalOpen(false);
      setSaving(false )
    } 
  }

  if (loading) {
    return (
      <Box p={4} display="flex" justifyContent="center">
        <CircularProgress />
      </Box>
    );
  }

  if (!industryTrack) {
    return (
      <Box p={4}>
        <Typography color="error">Industry Track not found.</Typography>
      </Box>
    );
  }

  return (
    <div style={{ padding: 24 }}>
      <IconButton
        onClick={() => navigate("/industry-track")}
        sx={{
          backgroundColor: "#4D8FAC",
          color: "#fff",
          "&:hover": { backgroundColor: "#3b7694" },
          mb: 2,
        }}
      >
        <ArrowBackIcon />
      </IconButton>

      <Typography variant="h4" gutterBottom>
        {industryTrack["Industry Name"] || "Unnamed Industry"}
      </Typography>

      

      <Card sx={{ marginBottom: 3 }}>
        <CardContent>
          <Grid container spacing={2}>
            <DetailBlock label="Manager" value={industryTrack["Manager"]} />
            <DetailBlock label="SPOC 1" value={industryTrack["SPOC 1"]} />
            <DetailBlock label="SPOC 2" value={industryTrack["SPOC 2"]} />
            <DetailBlock label="SPOC 3" value={industryTrack["SPOC 3"]} />
            <DetailBlock label="Members" value={industryTrack["Members"]} isArray />
          </Grid>
          <Box sx={{ display: "flex", gap: 2}}>
          <Button
          onClick={handleOpenEdit}
          
          variant="solid"
          sx={{ marginTop: 2 ,backgroundColor:"#4D8FAC",  "&:hover": { backgroundColor: "#53a4c7ff" },} }
          title="Edit"
          endDecorator={<EditIcon />}
        >
          Edit
        </Button>
        <Button
          onClick={handleOpenDelete}
          endDecorator={<DeleteIcon />}
          variant="solid"
          sx={{ marginTop: 2 ,backgroundColor:"#4D8FAC","&:hover": { backgroundColor: "#53a4c7ff" }} }
          title="Delete"
        >
          Delete 
        </Button>
        </Box>
        </CardContent>
      </Card>
       <IndustryTrackModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSave={handleSave}
        loading={saving}
        setLoading={setSaving}
        initialData={modalInitialData}
        membersOptions={Array.isArray(industryTrack?.Members) ? industryTrack.Members : []}
        title={isMode === "edit" ? "Edit Industry Track" : ""}
        mode={isMode}
      />
      {isShowSnackbar && (
        <ReuseableSnackbar
          isShowSnackbar={isShowSnackbar}
          colour={snackbarInfo.color}
          setIsShowSnackbar={setIsShowSnackbar}
          message={snackbarInfo.message}
          autoHideDuration={2000}
        />
      )}
    </div>
  );
};

interface DetailBlockProps {
  label: string;
  value?: string | string[];
  isArray?: boolean;
}

const DetailBlock: React.FC<DetailBlockProps> = ({ label, value, isArray }) => (
  <Grid item xs={12}>
    <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1 }}>
      {label}
    </Typography>
    {isArray && Array.isArray(value) && value.length > 0 ? (
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 2 }}>
        {(value as string[]).map((item, i) => (
          <Chip key={i} label={item} variant="outlined" />
        ))}
      </Box>
    ) : value ? (
      <Typography variant="body1" sx={{ mb: 2 }}>
        {value}
      </Typography>
    ) : (
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        No {label.toLowerCase()} available
      </Typography>
    )}
    <Divider />
  </Grid>
);

export default IndustryTrackDetails;
